/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createAcoth } from '../../factoriesAny.js';
export var acothDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  ComplexDependencies: ComplexDependencies,
  typedDependencies: typedDependencies,
  createAcoth: createAcoth
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAcoth.generated.js
// module id = 1475
// module chunks = 0